module.exports = __webpack_public_path__ + "static/media/Group 3@3x.1a003de7.jpg";